import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import { AdminRoute, ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import SignIn from "@/pages/auth/SignIn";
import SignUp from "@/pages/auth/SignUp";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import VerifyEmail from "@/pages/auth/VerifyEmail";
import Setup from "@/pages/Setup";
import Dashboard from "@/pages/Dashboard";
import Devices from "@/pages/Devices";
import Integrations from "@/pages/Integrations";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import OAuthConsent from "@/pages/OAuthConsent";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/setup" element={<Setup />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/devices" element={<Devices />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/oauth/consent" element={<OAuthConsent />} />
              </Route>
              <Route element={<AdminRoute />}>
                <Route path="/admin" element={<Admin />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
